import { Country } from "../Country.js";
import type { CountrySettings } from "../CountrySettings.js";
import type { EconomicSubjectVatType } from "../EconomicSubjectVatType.js";
import { getStandardTaxRate } from "./getStandardTaxRate.js";
import { shouldApplyOSS } from "./shouldApplyOSS.js";
import { shouldApplyTax } from "./shouldApplyTax.js";

/**
 * Membership is an electronically supplied service, so it is taxed at the standard rate of the destination country
 * under OSS, at the Czech standard rate otherwise, and not at all when no tax applies (e.g. reverse charge).
 */
export function getMembershipTaxRate(
	destinationCountry: Country | "outsideEu",
	vatType: EconomicSubjectVatType,
	countrySettings: CountrySettings[],
): number {
	if (!shouldApplyTax(destinationCountry, vatType)) {
		return 0;
	}

	if (destinationCountry !== "outsideEu" && shouldApplyOSS(destinationCountry, vatType)) {
		return getStandardTaxRate(destinationCountry, countrySettings);
	}

	return getStandardTaxRate(Country.Czechia, countrySettings);
}
